import { List, useTable, EditButton, ShowButton, CreateButton } from '@refinedev/antd';
import { Table, Tag } from 'antd';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { BidiText, formatDateBidi } from '@lebinatikra/rtl-utils';

interface GroupRow {
  id: string;
  organization_id: string;
  name: string;
  type: string;
  auto_created_via: string | null;
  member_count: number;
  created_at: string;
}

export function GroupList() {
  const { t } = useTranslation();
  const { organizationId } = useParams();
  const { tableProps } = useTable<GroupRow>({
    resource: 'groups',
    pagination: { pageSize: 25 },
    meta: { parentId: organizationId },
  });

  return (
    <List headerButtons={() => <CreateButton>{t('actions.create_group')}</CreateButton>}>
      <Table {...tableProps} rowKey="id">
        <Table.Column<GroupRow>
          dataIndex="name"
          title={t('common.name')}
          render={(v) => (
            // rtl-utils:bidi-wrapped
            <BidiText>{v}</BidiText>
          )}
        />
        <Table.Column<GroupRow>
          dataIndex="type"
          title={t('fields.type')}
          render={(v) => <Tag>{v}</Tag>}
        />
        <Table.Column<GroupRow>
          dataIndex="auto_created_via"
          title={t('fields.auto_created_via')}
          render={(v) => (v ? <Tag color="purple">{v}</Tag> : <Tag>Manual</Tag>)}
        />
        <Table.Column<GroupRow>
          dataIndex="member_count"
          title={t('fields.member_count')}
          render={(v: number) => v ?? 0}
        />
        <Table.Column<GroupRow>
          dataIndex="created_at"
          title={t('common.created_at')}
          render={(v) => formatDateBidi(v)}
        />
        <Table.Column<GroupRow>
          title={t('common.actions')}
          render={(_, record) => (
            <>
              <ShowButton hideText size="small" recordItemId={record.id} />
              <EditButton hideText size="small" recordItemId={record.id} />
            </>
          )}
        />
      </Table>
    </List>
  );
}
